import type { JSX } from 'react';

import { CardCarousel } from './components/CardCarousel';
import { QRPosterCard } from './components/QRPoster/components/QRPosterCard/variant2';
import { SocialContentCard } from './components/SocialContent/components/SocialContentCard/variant2';

export function Variant2(): JSX.Element {
	const items = [
		{
			key: 'social-content',
			component: <SocialContentCard />,
		},
		{
			key: 'qr-poster',
			component: <QRPosterCard />,
		},
	];
	return (
		<div className="w-full px-1 py-2 md:px-12 md:py-12">
			<CardCarousel items={items} />
		</div>
	);
}
